<template>
  <header id="indexOwl" class="site-banner" data-ga-label="Sliders-首頁輪播">
    <div ref="slider" class="banner-slider owl-carousel owl-theme">
      <template v-for="banner in banners">
        <iframe v-if="isVideo(banner)" :key="banner.id" ref="video" :src="getPlayerSrc(banner)"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
          allowfullscreen="1" data-gtm-yt-inspected-1_25="true" data-is-ready="true" frameborder="0" style="height: 40vw"
          width="100%" />
        <a v-else :key="banner.id" :href="banner.banner_link == '' ? 'javascript:void(0)' : banner.banner_link"
          :title="banner.name" :target="banner.banner_link == '' ? '_self' : '_blank'" :alt="banner.name"
          :style="banner.banner_link == '' ? 'cursor: default;' : 'cursor: pointer;'">
          <div :style="`background-image:url(./${banner.images.banner});`" class="desktop-only landscape lazyload" />
          <div :style="`background-image:url(./${banner.images.banner_mobile});`"
            class="mobile-only banner-portrait lazyload" />
        </a>
      </template>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    banners: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      carousel: null,
      videoPlayers: [],
      starPoint: {},
      isFirstTouch: false,
      isMove_LeftRight: false,
    }
  },
  computed: {
    firstIsVideo() {
      return this.isVideo(this.banners[0])
    },
  },
  mounted() {
    $(document).one('lazybeforeunveil', () => {
      this.carousel.trigger('refresh.owl.carousel')
    })

    $(this.$refs.slider)
      .find('[data-due]')
      .filter(function () {
        return new Date().getTime() > new Date(this.getAttribute('data-due')).getTime()
      })
      .remove()

    this.carousel = $(this.$refs.slider)
      .owlCarousel({
        loop: true,
        navigation: true,
        singleItem: true,
        items: 1,
        autoHeight: true,
        nav: true,
        autoplay: !this.firstIsVideo,
        autoplayTimeout: 5000,
        onTranslate: (event) => {
          // Before next banner
          const video = this.getVideoFrame()
          if (video !== undefined) {
            video.player.stopVideo()
          }
        },
        onTranslated: (event) => {
          // after banner changed
          // https://developers.google.com/youtube/iframe_api_reference#Examples
          const video = this.getVideoFrame()
          if (video?.player) {
            // Stop autoplay if is video
            this.carousel.options.autoplay = false
            video.player.mute()
            video.player.playVideo()
          } else {
            this.carousel.options.autoplay = true
          }
          this.carousel.refresh()
        },
      })
      .data('owl.carousel')
    this.$nextTick(this.loadYoutubeApi)
    this.touchOptimize()

  },
  methods: {
    touchOptimize() {
      // 減少使用者斜角方向滑動時，輪播播頁與頁面滾動打架。例如向左上滑動角度小於45度(大約)會判斷為水平滑動
      let vm = this
      let dom = document.querySelector("#indexOwl")
      if (dom !== null) {
        dom.addEventListener("touchstart", (e) => {
          let touch = e.changedTouches[0];
          this.starPoint = {
            x: touch.pageX,
            y: touch.pageY
          }
          this.isFirstTouch = true;
        })
        dom.addEventListener("touchmove", (e) => {
          let touch = e.changedTouches[0];
          let nowPoint = {
            x: touch.pageX,
            y: touch.pageY
          };
          let dis = {
            x: nowPoint.x - this.starPoint.x,
            y: nowPoint.y - this.starPoint.y
          }
          if (this.isFirstTouch) {
            if (Math.abs(dis.x) - Math.abs(dis.y) > 5) {
              this.isFirstTouch = false;
              this.isMove_LeftRight = true;
            } else {
              this.isMove_LeftRight = false;
            }

            if (this.isMove_LeftRight) {
              // 判斷為左右滑動，阻止頁面滾動
              e.preventDefault();
            }
            //  避免移動中重複判斷
            this.isFirstTouch = false;
          }
        })
      } else {
        // 網頁還未完全加載好
        setTimeout(function () {
          vm.touchOptimize()
        }, 200)
      }




    },
    getPlayerSrc({ banner_youtube_id }) {
      return `https://www.youtube.com/embed/${banner_youtube_id}?rel=0&playsinline=1&autoplay=0&enablejsapi=1`
    },
    isVideo(banner) {
      return banner.banner_youtube_id
    },
    loadYoutubeApi() {
      if (typeof window.YT?.Player === 'function') {
        this.onYouTubeIframeAPIReady()
      } else {
        window.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady
      }
      const tag = document.createElement('script')
      tag.src = 'https://www.youtube.com/iframe_api'
      const firstScriptTag = document.getElementsByTagName('script')[0]
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
    },
    onYouTubeIframeAPIReady() {
      this.$refs.video?.forEach((video) => {
        const player = new window.YT.Player(video, {
          events: {
            onStateChange: this.onPlayerStateChange,
          },
        })
        video.player = player
        this.videoPlayers.push(player)
      })
      // 載入 API 後一陣子才會出現 playVideo function
      setTimeout(() => {
        const video = this.getVideoFrame()
        if (video?.player) {
          video.player.mute()
          video.player.playVideo()
        }
      }, 800)
    },
    onReady() { },
    onPlayerStateChange({ target, data }) {
      if (data === 0) {
        // Video Ended
        this.nextBanner()
      }
    },
    getVideoFrame() {
      return $(this.$el).find('.owl-item.active iframe[src*=youtu]').get(0)
    },
    nextBanner() {
      this.carousel.next()
    },
  },
}
</script>

<style lang="stylus">
// 透過owl插件後來生出來的dom元素，會無法套用scoped生成的styleID，改用設定id的方式
#indexOwl.site-banner
  background #000
  .owl-dots
    position absolute
    padding 1rem
    bottom 0
    left 0
    right 0
    pointer-events none
    .owl-dot
      pointer-events all
      span
        border-radius 50%
        background alpha(white, .5)
    .owl-dot.active span
      background white

  .owl-nav
    position absolute
    z-index 1
    top 0
    width 100%
    margin 0
    .owl-prev,.owl-next
      position absolute
      top 0%
      max-width 55px
      // max-height 88px
      width 8vw
      // height 8vw
      height: 37vw;
      max-height calc(100vh - 270px)
      padding 0
      display block
      text-indent -999999px
      background-size contain
      background-repeat no-repeat
      background-color inherit
      background-position 0 55%
      @media (max-width 767px)
        height 110vw !important
        max-height calc(100vh - 100px)
    .owl-prev
      left 2%
      background-image url('~@/../assets/images/icon-left2.png')
    .owl-next
      right  2%
      background-image url('~@/../assets/images/icon-right2.png')
  iframe
    max-height calc(100vh - 200px)
    @media (max-width 767px)
      max-height calc(100vh - 60px)
      height 155vw !important
      padding-bottom 10vw
  .landscape
    // pc版
    background #EFEFEF
    background-position top center
    background-size cover
    height 40vw
    max-height calc(100vh - 200px)
    position relative

  .banner-portrait
    //md版
    background #EFEFEF
    background-position center center
    background-size cover
    width 100%
    max-height calc(100vh - 60px)
    height 155vw
    // padding-top (1000 / 640) * 100%
    position relative

  .lazyload, .lazyload *
    //圖片片加載完成時
    background-image none !important

@media (min-height 1280px)
  #indexOwl.site-banner .landscape
    // max-height 1080px
</style>
